import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input, HostBinding } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EnvironmentService } from 'providers/environment.service';
import { ConfigService } from 'providers/config.service';
import { BetaLinkService } from '../../layout-service/beta-link.service';
import { BetaNotificationDialog } from '../../beta-notification-dialog/beta-notification-dialog.component';

const STORAGE_KEY = 'ce-product-updates-last-seen';

@Component({
    selector: 'ce-release-info',
    templateUrl: './release-info.component.html',
    styleUrls: ['./release-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
@UntilDestroy()
export class ReleaseInfoComponent implements OnInit {
    @Input() @HostBinding('class') public themeClass: 'theme-mykempower' | 'theme-chargeye' = 'theme-chargeye';

    constructor(
        private http: HttpClient,
        private cdRef: ChangeDetectorRef,
        private environmentService: EnvironmentService,
        private configService: ConfigService,
        private betaLinkService: BetaLinkService
    ) {
        this.environmentService
            .getAppOrigin$()
            .pipe(untilDestroyed(this))
            .subscribe((origin) => {
                this.themeClass = `theme-${origin}`;
                this.cdRef.markForCheck();
            });
    }

    displayNotification = false;

    ngOnInit(): void {
        this.checkForNewProductUpdates();
    }

    onClick() {
        this.displayNotification = false;
        this.cdRef.markForCheck();
        const productUpdatesUrl = `https://${this.configService.config.apiBaseUrl}/2.0/help/product-updates`;
        this.betaLinkService.navigateToBeta(undefined, BetaNotificationDialog, productUpdatesUrl);
    }

    private checkForNewProductUpdates(): void {
        const cdn = this.configService?.config.contentCdn;
        if (!cdn) return;

        const headers = new HttpHeaders({ 'X-Delivery-Token': cdn.deliveryToken });
        this.http
            .get<{ items?: { publishedAt?: string }[] }>(`${cdn.url}/api/content/cdn/feeds/${cdn.stage}`, {
                headers,
                params: { limit: '50' },
            })
            .pipe(untilDestroyed(this))
            .subscribe({
                next: (res) => {
                    const items = res.items ?? [];
                    const lastSeen = this.getLastSeen();
                    const newCount = lastSeen
                        ? items.filter((i) => i.publishedAt && i.publishedAt > lastSeen).length
                        : items.length;
                    this.displayNotification = newCount > 0;
                    this.cdRef.markForCheck();
                },
            });
    }

    private getLastSeen(): string | null {
        try {
            return localStorage.getItem(STORAGE_KEY);
        } catch {
            return null;
        }
    }
}
